export default class DiagramConfiguration {
    public spiderConfig = new SpiderConfig()
    public bubbleConfig = new BubbleConfig()
    public timelineConfig = new TimelineConfig()
}

class SpiderConfig {
    public nodeShape: string = ''
}

class BubbleConfig {
    public topLeftQuadrantName: string = ''
    public topRightQuadrantName: string = ''
    public bottomLeftQuadrantName: string = ''
    public bottomRightQuadrantName: string = ''
}

class TimelineConfig {
    public phaseNames = new Array<PhaseName>()
    public dateRange = new Array<PointInTime>()
    public rangeMode: string = ''
}

class PhaseName {
    public number: string = '1'
    public name: string = ''
}

class PointInTime {
    public label: string = 'From'
    public date: string = ''
}
